import { archivePuzzleCount } from '../../controllers/archive'
import { useLocation } from 'wouter'
import ArchiveIcon from '../Icon/ArchiveIcon'
import Box from '../Box'
import Button from '../Button'
import TomAvatar from '../../img/tom-avatar.jpg'
import logGoogleEvent from '../../util/logEvent'

const ArchiveAnnouncement = () => {
	const archiveCount = archivePuzzleCount()
	const [, navigate] = useLocation()

	return (
		<Box className="pgm-archive-announcement">
			<h2>Exciting News</h2>
			<p>Good day fellow word&#8209;sleuth!</p>
			<p>
				After significant demand – and much, much later than we had imagined – we are{' '}
				<em>finally</em> able to present to you the...
			</p>
			<div className="pgm-archive-announcement-graphic">
				<ArchiveIcon />
				<span>
					One Word Search
					<br />
					Archive
				</span>
			</div>
			<p>
				That’s right! All <strong>{archiveCount} previous puzzles</strong> are now available
				for you to enjoy at your leisure.
			</p>
			<p>
				It is an absolute delight for me to deliver them to you after so long. Fair warning
				though, they're quite moreish!
			</p>
			<div className="post-game-message__signature">
				<span className="post-game-message__name">
					<p>- Tom</p>
				</span>
				<div className="post-game-message__avatar">
					<img src={TomAvatar} />
				</div>
			</div>
			<p>Would you like to try the very first?</p>
			<Button
				name="archive-announcement-play"
				className="button--blue"
				onClick={() => {
					logGoogleEvent('pgm_archiveAnnouncement_click')
					navigate(`/archive/daily/1`)
				}}
			>
				Play Daily Search #1
			</Button>
			<small>
				<em>P.S. You can access the Archive at any time via the menu.</em>
			</small>
		</Box>
	)
}

export default ArchiveAnnouncement
